import { FC } from 'react';
import './LoadingButton.scss';

type CustomButtonProps = {
  isLoading: boolean;
  onClick: () => void;
  text: string;
  className?: string;
  icon?: string;
  disabled?: boolean;
};

const LoadingButton: FC<CustomButtonProps> = ({
  isLoading,
  onClick,
  text,
  className = '',
  icon,
  disabled = false,
}) => (
  <button
    type="button"
    className={className}
    onClick={onClick}
    disabled={isLoading || disabled}
  >
    {!isLoading && icon && <em className={`icon ni ${icon} mr-1`} />}
    {isLoading ? (
      <div className="spinner-border spinner-border-sm mr-1" role="status" />
    ) : null}
    {text}
  </button>
);

export default LoadingButton;
